/* eslint max-len:0 */
import React from 'react'

function RightArrow({ handleClick, className }) {
  return (
    <svg
      className={className}
      onClick={handleClick}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="10"
      viewBox="0 0 17 10"
    >
      <path d="M14.785 5.5H1.002a.501.501 0 1 1 0-1h13.783l-3.16-3.146a.498.498 0 0 1 0-.708.504.504 0 0 1 .71 0l4.018 4a.498.498 0 0 1 0 .708l-4.018 4a.504.504 0 0 1-.71 0 .498.498 0 0 1 0-.708l3.16-3.146z" />
    </svg>
  )
}

export default RightArrow
